<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Logs'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-error-message
        [text]="errorMessage" />
      @if ((logHistory?.length ?? 0) === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'No Logs Avaliable.'" />
          </tidy-row>
        </tidy-alert>
      }
      @for (log of logHistory; track log) {
        <tidy-card>
          <tidy-card-button (action)="goToLogDetails(log)">
            <tidy-row>
              <tidy-text
                [header]="log?.response.status_code + ' '" />
              <tidy-text
                [body]="log?.request.method + ' '" />
              <tidy-text
                [body]="log?.request.path + ' - '" />
              <tidy-text
                [helper]="(log?.created_at | parseDateTime:'MMM d':'local') + ' ' + (log?.created_at | parseDateTime:'h:mma':'local')" />
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ng-container *ngTemplateOutlet="content" />
}
